import { TranslationObject } from '@ngx-translate/core';

const fr: TranslationObject = {
  fr: 'Français',
  app: {
    test: 'Ceci est une étiquette de test',
    title: 'SWD - Discipline de Travail',
    welcomeMessage: 'Bienvenue dans l\'application web SWD',
    forms: {
      ok: 'Ok',
      cancel: 'Annuler',
      create: 'Créer',
      continue: 'Continuer',
      labels: {
        businessUnit: 'Unité d\'affaires',
        placeholderBusinessUnit: 'Sélectionnez une Unité d\'affaires',
        user: 'Utilisateur',
        name: 'Nom',
        description: 'Description',
        placeHolderDescription: 'Entrez une description',
        placeHolderReviewType: 'Sélectionnez un type de revue',
        mandatory: 'Obligatoire',
      },
      unsavedChangesWarning:
        'Des modifications non enregistrées ont été détectées. Si vous quittez cette page, les modifications que vous avez apportées seront perdues.<br>Voulez-vous continuer?',
    },
    warnings: {
      removeOwnAdminRights:
        'Vous avez supprimé vos droits d\'administrateur. Veuillez actualiser la page web pour éviter tout dysfonctionnement.',
      removeOwnAccess:
        'Vous avez supprimé votre accès. Veuillez actualiser la page web pour éviter tout dysfonctionnement.',
    },
  },
  navigation: {
    startWorkDone: 'Observations',
    category: 'Catégories',
    businessUnits: 'Unités d\'affaires',
    administration: 'Administration',
    sysAdmins: 'Administrateurs Système',
    users: 'Utilisateurs',
    areas: 'Zones',
    errorReductionTools: 'Outils de réduction des erreurs',
    nonBadgedPersons: 'Personnes observées sans badge',
  },
  startWorkDoneList: {
    title: 'Observations',
    noStartWorkDone:
      'Sélectionnez une Unité d\'affaires, une Zone, une Sous-zone, une Catégorie et une Personne observée pour afficher les enregistrements',
    emptyList: 'Aucun enregistrement de discipline de travail trouvé pour les filtres sélectionnés',
    id: 'ID',
    question: 'Contrôle',
    answer: 'Réponse',
    score: 'Score',
    comment: 'Commentaire',
    errorReductionTool: 'Outil de réduction des erreurs',
    updatedBy: 'Mis à jour par',
    updatedDate: 'Date de mise à jour',
    createNewStartWorkDone: 'créer un nouveau travail de démarrage',
    reviewType: 'Type de revue',
    area: 'Zone',
    observationDate: 'Date d\'observation',
    subArea: 'Sous-zone',
    category: 'Catégorie',
    placeholderArea: 'Sélectionner une zone',
    placeholderSubArea: 'Sélectionner une sous-zone',
    placeholderCategory: 'Sélectionner une catégorie',
    addQuestion: 'Ajouter un Contrôle',
    description: 'Description',
    subSection: 'Sous-section',
    clearAnswer: 'Effacer la Réponse',
    deleteQuestion: 'Supprimer le Contrôle',
    deleteQuestionTitle: 'Supprimer le Contrôle',
    confirmDeleteQuestion:
      '<span>Êtes-vous sûr de vouloir supprimer ce contrôle?</span><br><br><span><b>Contrôle:</b> {{ description }}</span>',
    editQuestion: 'Modifier le Contrôle',
    editQuestionHeader: 'Modifier le Contrôle',
    userSearch: 'Personne observée',
    userSearchPlaceholder: 'Rechercher par nom ou email...',
    supervisor: 'Superviseur',
    noSupervisor: 'Aucun superviseur trouvé',
    nonBadgedPersonObserved: 'Personne observée sans badge',
    placeholderNonBadgedPersonObserved: 'Sélectionner une personne sans badge',
    personSelectionConflict:
      'Un seul des champs suivants peut être renseigné : Personne observée ou Personne observée sans badge.',
    generateReport: 'Générer le Rapport',
    completeReview: 'Terminer et Envoyer le Rapport',
    generateReportInfoMessage:
      'Votre rapport est en cours de génération et sera téléchargé automatiquement. Cela peut prendre quelques instants.',
    generateSuccessMessage: 'Rapport généré avec succès',
    reviewSuccessMessage: 'Rapport d\'observation SWD envoyé avec succès',
    sendEmail: 'Envoyer Email',
    emailSuccessMessage: 'Email envoyé avec succès',
    emailErrorMessage: 'Erreur lors de l\'envoi de l\'email',
    tableColumns: {
      businessUnit: 'Unité d\'affaires',
      category: 'Catégorie',
      subArea: 'Sous-zone',
      area: 'Zone',
      user: 'Personne observée',
      nonBadgedPerson: 'Personne observée sans badge',
      supervisor: 'Superviseur',
      observationDate: 'Date d\'observation',
      totalScore: 'Score total',
      createdBy: 'Observateur',
    },
    viewEdit: 'Voir / Modifier',
  },
  startWorkDoneDetail: {
    title: 'Observation',
    details: 'Informations Générales',
    notFound: 'Enregistrement de discipline de travail introuvable',
    accessDenied: 'Vous n\'avez pas accès à cette observation.',
    saveSuccess: 'Enregistrement mis à jour avec succès',
    editInfo: 'Modifier les informations',
    saveInfo: 'Enregistrer les informations',
    errorReductionTools: 'Outils de réduction des erreurs',
    noControls: 'Aucun contrôle trouvé. Ajoutez d\'abord des contrôles à cette catégorie.',
    totalScore: 'Score Total',
    deleteObservation: 'Supprimer l\'observation',
    deleteConfirmTitle: 'Supprimer l\'observation',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette observation ? Cette action est irréversible.',
    deleteSuccess: 'Observation supprimée avec succès',
    noObservationDate:
      'Aucune date d\'observation n\'a été sélectionnée. Veuillez sélectionner une date avant de terminer cette révision.',
  },

  categoryList: {
    title: 'Catégories',
  },
  admin: {
    sysAdminList: {
      title: 'Administrateurs Système',
      addSysAdmin: 'ajouter un administrateur système',
      fullName: 'nom complet',
      email: 'email',
      dialogs: {
        removeAccessHeader: 'Confirmation',
        removeAccessMessage:
          'Êtes-vous sûr de vouloir supprimer l\'accès administrateur système pour : [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Unités d\'affaires',
      addBusinessUnit: 'ajouter une unité d\'affaires',
      tableTitle: 'Unité d\'affaires',
      noBusinessUnits: 'Aucune unité d\'affaires trouvée.',
      dialogs: {
        createHeader: 'Créer une unité d\'affaires',
        namePlaceholder: 'Entrez un nom',
      },
    },
    businessUnitEdit: {
      title: 'Modifier l\'unité d\'affaires',
    },
    errorReductionTools: {
      title: 'Outils de réduction des erreurs',
      addErt: 'ajouter un outil de réduction des erreurs',
      tableTitle: 'outil de réduction des erreurs',
      noErts: 'Aucun outil de réduction des erreurs trouvé.',
      dialogs: {
        createHeader: 'Créer un outil de réduction des erreurs',
        editHeader: 'Modifier l\'outil de réduction des erreurs',
        namePlaceholder: 'Entrez un nom',
        deleteTitle: 'Supprimer l\'outil de réduction des erreurs',
        deleteMessage:
          'Êtes-vous sûr de vouloir supprimer l\'outil de réduction des erreurs <strong>{{name}}</strong> ?',
        deleteSuccess: 'Outil de réduction des erreurs supprimé avec succès.',
        deleteConflict:
          'Cet outil de réduction des erreurs ne peut pas être supprimé car il est associé à un ou plusieurs contrôles.',
      },
    },
    nonBadgedPersons: {
      title: 'Personnes observées sans badge',
      addPerson: 'ajouter une personne observée sans badge',
      importPeople: 'importer les utilisateurs de permis sans badge',
      noPeople: 'Aucune personne sans badge trouvée.',
      columns: {
        name: 'personne observée sans badge',
        supervisorEmail: 'email du superviseur',
        supervisorName: 'nom du superviseur',
      },
      dialogs: {
        createHeader: 'Ajouter une personne observée sans badge',
        editHeader: 'Modifier la personne observée sans badge',
        nameLabel: 'Personne sans badge',
        nameRequired: 'Le nom est obligatoire',
        supervisorLabel: 'Superviseur',
        supervisorPlaceholder: 'Rechercher par nom ou email...',
        supervisorRequired: 'L\'email est obligatoire',
        deleteTitle: 'Supprimer la personne sans badge',
        deleteMessage: 'Êtes-vous sûr de vouloir supprimer la personne sans badge <strong>{{name}}</strong> ?',
        deleteSuccess: 'Personne sans badge supprimée avec succès.',
        deleteConflict:
          'Cette personne sans badge ne peut pas être supprimée car elle a participé à une ou plusieurs observations.',
        importHeader: 'Importer des personnes observées sans badge',
        attachDocument: 'Joindre un document',
        uploadedOn: 'Téléversé le {{date}}',
        removeFile: 'Retirer le fichier',
        invalidFile: 'Sélectionnez un seul fichier Excel (.xlsx) de 5 Mo maximum.',
        importFailed: 'Rien n\'a été importé. Corrigez ces erreurs et réessayez :',
        importSuccess: 'Importation terminée. Importées : {{imported}}. Doublons ignorés : {{skipped}}.',
      },
    },
    areas: {
      title: 'Zones',
      areasTitle: 'Zones',
      subAreasTitle: 'Sous-zones',
      addArea: 'Ajouter une zone',
      addSubArea: 'Ajouter une sous-zone',
      areaName: 'Nom',
      subAreaName: 'Sous-zones',
      category: 'Catégorie',
      noAreas: 'Aucune zone disponible.',
      noSubAreas: 'Aucune sous-zone disponible.',
      selectAreaMessage: 'Sélectionnez une zone pour gérer ses sous-zones.',
      dialogs: {
        createAreaHeader: 'Créer une zone',
        editAreaHeader: 'Modifier la zone',
        createSubAreaHeader: 'Créer une sous-zone',
        editSubAreaHeader: 'Modifier la sous-zone',
        namePlaceholder: 'Entrez un nom',
        category: 'Catégorie',
        categoryPlaceholder: 'Sélectionnez une catégorie (facultatif)',
        deleteAreaTitle: 'Supprimer la zone',
        deleteAreaMessage: 'Êtes-vous sûr de vouloir supprimer la zone <strong>{{name}}</strong> ?',
        deleteAreaLinkedRecords:
          'Impossible de supprimer cette zone car elle est liée à des enregistrements de discipline de travail.',
        deleteSubAreaTitle: 'Supprimer la sous-zone',
        deleteSubAreaMessage: 'Êtes-vous sûr de vouloir supprimer la sous-zone <strong>{{name}}</strong> ?',
        deleteSubAreaLinkedRecords:
          'Impossible de supprimer cette sous-zone car elle est liée à des enregistrements de discipline de travail.',
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Non enregistré',
      forms: {
        submit: 'Demander l\'accès',
      },
      dialogTitle: 'Demander l\'accès',
      dialogSubtitle:
        'Vous êtes sur le point de demander l\'accès pour <strong>{{name}}</strong>, voulez-vous continuer?',
      reloadWarning:
        'Si vous consultez cette page mais avez déjà accès, veuillez cliquer sur le lien suivant pour recharger, sinon contactez le support.',
      reload: 'Recharger',
    },
    pendingAccess: {
      title: 'Bonjour, votre demande d\'accès est en cours',
      reloadWarning:
        'Si vous consultez cette page mais avez déjà accès, veuillez cliquer sur le lien suivant pour recharger, sinon contactez le support.',
      reload: 'Recharger',
    },
  },
  header: {
    logoAlt: 'Logo CVX',
    userAvatarAlt: 'Avatar de l\'utilisateur',
    unknownUser: 'Inconnu',
  },
  footer: {
    text: 'Chevron Corporation. Tous droits réservés.',
    version: 'SWD v{{ version }}',
  },
  category: {
    title: 'Catégories',
    create: 'Créer',
    name: 'Nom',
    description: 'Description',
    actions: 'Actions',
    edit: 'Modifier',
    manage: 'Gérer',
    delete: 'Supprimer',
    confirmDelete:
      '<span>Êtes-vous sûr de vouloir supprimer cette catégorie ?</span><br><br><span>Nom : {{ name }}<br>Description : {{ description }}</span>',
    noCategories: 'Aucune catégorie disponible.',
    titleCreate: 'Créer une catégorie',
    createNew: 'Créer une nouvelle',
    selectPlaceholder: 'Choisissez-en un...',
    titleEdit: 'Modifier la catégorie',
    titleDelete: 'Supprimer la catégorie',
    deletedSuccessfully: 'Catégorie supprimée avec succès',
    importCategory: 'Importer la catégorie',
    importCategoryTitle: 'Importer la catégorie dans ',
    selectCategoryType: 'Sélectionner le type de catégorie',
    confirm: 'Confirmer',
    importSuccessMessage: 'Catégorie importée avec succès',
    manageControls: 'Gérer les contrôles',
    noControls: 'Aucun contrôle disponible.',
    selectBusinessUnit: 'Sélectionnez une unité commerciale pour afficher les contrôles',
    importCategoriesTitle: 'Importer les Catégories',
    import: 'Importer',
  },
  common: {
    selectAnswer: 'Select answer',
    noAttempt: 'No Attempt',
    needsImprovement: 'Needs Improvement',
    meetsExpectations: 'Meets Expectations',
    exceedsExpectations: 'Exceed Expectations',
    save: 'Enregistrer',
    businessUnit: 'Unité commerciale',
    forbidActionErrorMessage: ' L\'utilisateur n\'est pas autorisé à effectuer cette action.',
    name: 'Nom',
    code: 'Code',
    cancel: 'Annuler',
    genericErrorMessage: 'Une erreur inattendue est survenue. Veuillez réessayer plus tard.',
    savedSuccessfully: 'Enregistré avec succès',
    delete: 'Supprimer',
    deletedSuccessfully: 'Supprimé avec succès',
    edit: 'Modifier',
    leaveWithOutSaving: 'Quitter sans enregistrer',
    language: 'Langue',
    view: 'Voir',
    back: 'Retour',
    createdBy: 'Créé par',
    updatedBy: 'Mis à jour par',
    updatedDate: 'Date de mise à jour',
    errors: {
      failedToSubmit: 'Échec de l\'envoi de la réponse. Veuillez réessayer.',
    },
  },
  serverError: {
    title: 'Serveur indisponible',
    message: 'Impossible de se connecter au serveur. Veuillez vérifier votre connexion réseau ou réessayer plus tard.',
    returnHome: 'Retour à l\'accueil',
  },
  pageNotFound: {
    title: 'Page introuvable',
    message: 'La page que vous recherchez n\'existe pas.',
    returnHome: 'Retour à l\'accueil',
  },
  unauthorized: {
    title: 'Accès non autorisé',
    message: 'Vous n\'avez pas l\'autorisation d\'accéder à cette page.',
    returnHome: 'Retour à l\'accueil',
  },
  categoryForm: {
    title: 'Créer une liste de contrôle',
    successCreationMessage: 'Crear Lista de Pendientes',
  },
  categoryManage: {
    title: 'Gérer le contenu de [{{ description }}]',
    questionsTitle: 'Contrôles',
    addQuestionAction: 'ajouter un contrôle',
    questionName: 'Contrôle',
    questionNamePlaceholder: 'Entrez le texte du contrôle',
    errorReductionTools: 'Outils de réduction des erreurs',
    ertPlaceholder: 'Sélectionnez des outils de réduction des erreurs',
    noQuestions: 'Aucun contrôle trouvé. Ajoutez un contrôle pour commencer.',
    sectionsTitle: 'Sections',
    subSectionsTitle: 'Sous-sections',
    addSectionAction: 'ajouter une section',
    mandatoryLabel: 'Obligatoire',
    createNewSubsectionAction: 'ajouter un groupe de contrôles',
    emptySubSectionsMessage:
      '<p>Il n\'y a aucun contenu disponible pour cette section.</p><p>Veuillez ajouter une sous-section pour commencer.</p>',
    itemDescriptionTableHeader: 'Description',
    createNewItemAction: 'Ajouter un contrôle',
    createSectionHeader: 'Créer une section',
    editSectionHeader: 'Modifier la section',
    confirmDeleteSection: 'Êtes-vous sûr de vouloir supprimer la section <strong>{{description}}</strong> ?',
    createSubSectionHeader: 'Ajouter un groupe de contrôles',
    editSubSectionHeader: 'Modifier la sous-section',
    createQuestionTitle: 'Créer un contrôle',
    ShouldAddCommentToQuestion: 'L utilisateur doit ajouter un commentaire à tout contrôle auquel la réponse est N/A',
    deleteQuestionTitle: 'Supprimer le contrôle',
    confirmDeleteQuestion:
      '<span>Êtes-vous sûr de vouloir supprimer ce contrôle ?</span><br><br><span><b>Description :</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Êtes-vous sûr de vouloir supprimer la sous-section <strong>{{description}}</strong> ?',
    deleteSectionHeader: 'Supprimer la section',
    deleteSubSectionHeader: 'Supprimer la sous-section',
    editQuestionTitle: 'Modifier le contrôle',
    defaultSubSectionName: 'Contrôles',
  },
  paginator: {
    previous: 'Précédent',
    next: 'Suivant',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} sur {{totalRecords}}',
  },
  usersList: {
    title: 'Utilisateurs',
    forms: {
      displayInactiveUsers: 'afficher les utilisateurs inactifs',
    },
    actions: {
      addNewUser: 'Ajouter un nouvel utilisateur',
      grantAccess: 'accorder l\'accès',
    },
    table: {
      fullName: 'nom complet',
      email: 'email',
      admin: 'admin',
    },
    noUsers: 'Aucun utilisateur disponible',
    dialogs: {
      removeAccessHeader: 'Confirmation',
      removeAccessMessage: 'Êtes-vous sûr de vouloir supprimer l\'accès pour : [{{fullName}}]?',
    },
  },
  actionItems: {
    title: 'actions',
    addActionItem: 'Ajouter une action',
    actionTitle: 'Titre',
    assignee: 'Assigné',
    date: 'Date',
    comment: 'Commentaire',
    id: 'ID',
    priority: 'Priorité',
    dialogs: {
      configureActionItem: 'Configurer l\'élément d\'action',
      configureComment: 'Commentaire',
      deleteActionItemHeader: 'Supprimer l\'élément d\'action',
      deleteActionItemMessage: 'Êtes-vous sûr de vouloir effectuer cette action?',
    },
  },
  comments: {
    title: 'Commentaires',
    addComment: 'Ajouter un commentaire',
    noComments: 'Aucun commentaire',
    dialogs: {
      configureComment: 'Commentaire',
      deleteCommentHeader: 'Effacer le commentaire',
      deleteCommentMessage: 'Êtes-vous sûr de vouloir effectuer cette action?',
    },
    comment: 'Commentaire',
    instructions: {
      title: 'Les commentaires doivent inclure:',
      observed: 'Ce qui a été observé',
      coaching: 'Le coaching fourni',
      action: 'L\'action prise pour résoudre les problèmes',
      feedback: 'Les retours positifs donnés pour avoir dépassé les attentes',
    },
  },
  features: {
    startWorkDone: {
      labels: {
        observationComment: 'Commentaire d\'Observation',
      },
      placeholders: {
        enterComment: 'Entrez vos commentaires de coaching ou le contexte de cette réponse...',
      },
      messages: {
        responseSubmitted: 'Réponse soumise avec succès',
        commentRequired: 'Un commentaire est requis pour ce type de réponse',
      },
      responseAnswers: {
        noAttempt: 'Aucune Tentative',
        needsImprovement: 'Doit Être Amélioré',
        meetsExpectations: 'Répond aux Attentes',
        exceedsExpectations: 'Dépasse les Attentes',
        notApplicable: 'Non Applicable',
      },
    },
  },
};
export default fr;
